import { render, staticRenderFns } from "./ShareTip.vue?vue&type=template&id=d5f22f74&scoped=true"
import script from "./ShareTip.vue?vue&type=script&lang=js"
export * from "./ShareTip.vue?vue&type=script&lang=js"
import style0 from "./ShareTip.vue?vue&type=style&index=0&id=d5f22f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f22f74",
  null
  
)

export default component.exports